import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BasicResponse } from '../../utils/basic-response/basic-response.model';
import { UserFormRedirectModalService } from '../user-form-redirect-modal/user-form-redirect-modal.service';
@Injectable({
  providedIn: 'root',
})
export class IsAddressCompleteGuard {
  constructor(
    private httpClient: HttpClient,
    private userFormRedirectModalService: UserFormRedirectModalService,
  ) {}

  canActivate(): Observable<boolean> {
    return this.httpClient
      .get<
        BasicResponse<boolean>
      >('/api/system/logged/user/petent/adres/checkiscomplete')
      .pipe(
        map((response) => response.Result),
        map((isComplete) => {
          if (!isComplete) {
            this.userFormRedirectModalService.open(true).subscribe();
          }
          return true;
        }),
      );
  }
}
